import { START_YEAR as S } from "./ghl-ui.es1304.js";
import b from "./ghl-ui.es1305.js";
import I from "./ghl-ui.es993.js";
import O from "./ghl-ui.es992.js";
import s from "./ghl-ui.es1306.js";
import f from "./ghl-ui.es994.js";
import w from "./ghl-ui.es1307.js";
import c from "./ghl-ui.es1308.js";
import Y from "./ghl-ui.es1309.js";
import A from "./ghl-ui.es1310.js";
import C from "./ghl-ui.es1311.js";
import N from "./ghl-ui.es1312.js";
import j from "./ghl-ui.es1313.js";
import Q from "./ghl-ui.es1314.js";
import p from "./ghl-ui.es1315.js";
import y from "./ghl-ui.es1316.js";
import g from "./ghl-ui.es1317.js";
import R from "./ghl-ui.es1318.js";
import D from "./ghl-ui.es1319.js";
import q from "./ghl-ui.es1320.js";
const x = {
  date: q,
  month: y,
  year: g,
  quarter: D
};
function u(r, e, t) {
  const o = x[t];
  return Array.isArray(r) ? r.some((n) => o(n, e)) : o(r, e);
}
function l(r, e, t, o) {
  let n = !1, a = !1, i = !1;
  Array.isArray(t) && (t[0] < r && r < t[1] && (n = !0), u(t[0], r, "date") && (a = !0), u(t[1], r, "date") && (i = !0));
  const d = t !== null && (Array.isArray(t) ? u(t[0], r, "date") || u(t[1], r, "date") : u(t, r, "date"));
  return {
    type: "date",
    dateObject: {
      date: Q(r),
      month: s(r),
      year: p(r)
    },
    inCurrentMonth: y(r, e),
    isCurrentDate: u(o, r, "date"),
    inSpan: n,
    startOfSpan: a,
    endOfSpan: i,
    selected: d,
    ts: f(r)
  };
}
function F(r, e, t) {
  return {
    type: "month",
    dateObject: {
      month: s(r),
      year: p(r)
    },
    isCurrent: y(t, r),
    selected: e !== null && u(e, r, "month"),
    ts: f(r)
  };
}
function k(r, e, t) {
  return {
    type: "year",
    dateObject: {
      year: p(r)
    },
    isCurrent: g(t, r),
    selected: e !== null && u(e, r, "year"),
    ts: f(r)
  };
}
function E(r, e, t) {
  return {
    type: "quarter",
    dateObject: {
      quarter: R(r),
      year: p(r)
    },
    isCurrent: D(t, r),
    selected: e !== null && u(e, r, "quarter"),
    ts: f(r)
  };
}
function nr(r, e, t, o, n = !1) {
  const a = s(r);
  let i = f(w(r)), d = f(c(i, -1));
  const m = [];
  let h = !n;
  for (; Y(d) !== o || h; )
    m.unshift(l(d, r, e, t)), d = f(c(d, -1)), h = !1;
  for (; s(i) === a; )
    m.push(l(i, r, e, t)), i = f(c(i, 1));
  const M = n ? m.length <= 28 ? 28 : m.length <= 35 ? 35 : 42 : 42;
  for (; m.length < M; )
    m.push(l(i, r, e, t)), i = f(c(i, 1));
  return m;
}
function or(r, e, t) {
  const o = [], n = A(r);
  for (let a = 0; a < 12; a++)
    o.push(F(f(C(n, a)), e, t));
  return o;
}
function ar(r, e, t) {
  const o = [], n = A(r);
  for (let a = 0; a < 4; a++)
    o.push(E(f(N(n, a)), e, t));
  return o;
}
function fr(r, e) {
  const t = [], o = new Date(S, 0, 1);
  for (let n = 0; n < 200; n++)
    t.push(k(f(j(o, n)), r, e));
  return t;
}
function ir(r, e, t, o) {
  const n = b(r, e, t, o);
  return I(n) ? O(n, e, o) === r ? n : /* @__PURE__ */ new Date(NaN) : n;
}
function ur(r) {
  if (r === void 0)
    return;
  if (typeof r == "number")
    return r;
  const [e, t, o] = r.split(":");
  return {
    hours: Number(e),
    minutes: Number(t),
    seconds: Number(o)
  };
}
function mr(r, e) {
  return Array.isArray(r) ? r[e === "start" ? 0 : 1] : null;
}
export {
  nr as dateArray,
  ur as getDefaultTime,
  or as monthArray,
  mr as pluckValueFromRange,
  ar as quarterArray,
  ir as strictParse,
  fr as yearArray
};
